import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { matchButtonConfig } from './data';
import '../assests/CSS/EmploymentRequirements.css';

const MatchButton = ({ variant = 'primary', showTooltip = false }) => {
  const location = useLocation();
  const navigate = useNavigate(); // added
  const searchData = location.state?.searchData || {};
  const selectedService = searchData.search || "EOR/PEO/AOR";
  const selectedCountry = searchData.location || "United States";

  const buttonText = matchButtonConfig.getButtonText(selectedService, selectedCountry);
  const serviceBenefit = matchButtonConfig.serviceBenefits[selectedService] || 
                        "Find the best service providers for your needs";

  const buttonClass = variant === 'secondary' 
    ? 'match-button secondary' 
    : 'match-button primary';

  const handleClick = () => {
    
    navigate("/#inquiry-form");
  };

  return (
    <div className="match-button-container">
      <button 
        className={buttonClass}
        aria-label={`Match with ${selectedService} providers in ${selectedCountry}`}
        onClick={handleClick} // added
      >
        {buttonText}
      </button>
      
      {showTooltip && (
        <div className="match-button-tooltip">
          {serviceBenefit}
          <span className="tooltip-arrow"></span>
        </div>
      )}
    </div>
  );
};

export default MatchButton;
